import * as React from 'react';
import { useState, useEffect } from 'react';
import { inject } from 'mobx-react';
import { useStores } from 'utility/hooks';
import { UitkLoadingBar, UitkLoadingBarType } from 'uitk-react-loading-bar';

const percInterval = 100;

export const ListingLoadingBar = inject()(() => {
  const {
    listingsStore: { progressBarDetails, pendingRequests },
    searchCriteriaStore
  } = useStores();
  const [progress, setProgress] = useState(0);

  const loadingTime =
    searchCriteriaStore &&
    searchCriteriaStore.searchCriteria &&
    ((searchCriteriaStore.searchCriteria.searchFilterValuesList &&
      searchCriteriaStore.searchCriteria.searchFilterValuesList.length > 0) ||
      searchCriteriaStore.searchCriteria.sortOption)
      ? progressBarDetails.sortAndFilterLatency
      : progressBarDetails.listingsLatency;
  const intervalInMS = loadingTime / percInterval;

  useEffect(() => {
    if (pendingRequests > 0) {
      setProgress(0);
    } else {
      setProgress(100);
    }

    const interval = setInterval(() => {
      setProgress(progress => progress + 100 / percInterval);
    }, intervalInMS);

    return () => clearInterval(interval);
  }, [intervalInMS, pendingRequests]);

  return (
    <div className="loader-spacing">
      <UitkLoadingBar percentLoaded={progress} type={UitkLoadingBarType.PERCENTAGE_CONTROL} />
    </div>
  );
});
